import React, { useContext, useEffect, useState } from 'react'
import { selectionDataContext } from '../../../hooks/context/SelectionDataContext'
import RelationshipQuery from "@arcgis/core/rest/support/RelationshipQuery.js";
import * as query from "@arcgis/core/rest/query.js";

/*
build the url with the properties from the feature.
url= `${feature.parentLayerUrl}/${feature.parentCustomParameters.OCLandInsightsId}`*/

const useSurveyRefDataHook = (layerIds,view) => {
  console.log('useSurveyRefDataHook layerIds',layerIds)

    var refRows = []
    const selectionDataCtx:any = useContext(selectionDataContext)
    const payload=selectionDataCtx.data
    const [featureDict,setfeatureDict]=useState({});
    const [columns,setColumns]=useState([]);
    const [rows,setRows]=useState([]);
    var Title_id = {};

    Title_id[layerIds["lotLineAdjustments"]] = "Lot Line Adjustments"
    Title_id[layerIds["recordsOfSurvey"]] = "Records of Survey"
    Title_id[layerIds["parcelMaps"]] = "Parcel Maps"
    Title_id[layerIds["tractMaps"]] = "Tract Maps"
    Title_id[layerIds["alignmentNotes"]] = "Alignment Notes"
    Title_id[layerIds["cornerRecords"]] = "Corner Records"
    Title_id[layerIds["topographicSurveys"]] = "Topographic Surveys"
    Title_id[layerIds["countySurveyorTieBooks"]] = "County Surveyor Tie Books"
    Title_id[layerIds["cityTies"]] = "City Ties"
    Title_id[layerIds["jackRaubNotes"]] = "Jack Raub Notes"

    //Related Table
let relateLLAcoc = new RelationshipQuery();
relateLLAcoc.outFields = ["*"];
relateLLAcoc.relationshipId = 2;

let relateRScoc = new RelationshipQuery();
relateRScoc.outFields = ["*"];
relateRScoc.relationshipId = 0;

let relatePMcoc = new RelationshipQuery();
relatePMcoc.outFields = ["*"];
relatePMcoc.relationshipId = 4;

let relateTRcoc = new RelationshipQuery();
relateTRcoc.outFields = ["*"];
relateTRcoc.relationshipId = 6;

    // let RS_layer = view.map.allLayers.filter((layer) => {
    //   return layer.layerId === fabricPointsId;
    // }) as any;

    
    // const payloadTC: any = useTCDataHook();

    
    useEffect(()=>{
      if(payload.length){
       // setColumns(refColumns);
        var featDict = {}
         let LLA_OIDs = []
         let RS_OIDs = []
         let PM_OIDs = []
         let TR_OIDs = []
         let coc_dict = {}
        console.log('payload MAIN',payload)
        payload.forEach(function (item, index) {
          console.log('payload Group Name', item.layerName)
          //[0].features[0].parentCustomParameters.OCLandInsightsID
         
            item.features.forEach(function (feature, index) { 
              console.log("OCLandInsightsID",feature.parentCustomParameters.OCLandInsightsID)
              featDict[item.layerName+feature.attributes.OBJECTID] = feature;
              let datevalue; 
              let engsvynum;
              let mapnum= '';
              let maptype;
              let docRef = '';
              let addtoRef = false;
              if (Title_id[feature.parentCustomParameters.OCLandInsightsID] == 'Corner Records'){
             
              engsvynum = feature.attributes.engsvynum;
              docRef = feature.attributes.crnum;
              maptype = 'Corner Record';
          //    featDict[item.layerName+feature.attributes.OBJECTID] = feature
              if (feature.attributes.Status == "Filed"){
                datevalue = new Date(feature.attributes.FiledDate).toDateString()
              } else {
                datevalue = new Date(feature.attributes.surveydate).toDateString()
              }
              addtoRef = true;
            }


            if (Title_id[feature.parentCustomParameters.OCLandInsightsID]  == 'Parcel Maps'){
              if ((feature.attributes.OBJECTID) && !PM_OIDs.includes(feature.attributes.OBJECTID)){
                PM_OIDs.push(feature.attributes.OBJECTID)
              }
              
              engsvynum = feature.attributes.EngSvyNum;
              mapnum = feature.attributes.PMNum;
              docRef = feature.attributes.Name 
              maptype = 'Parcel Map';
              datevalue = new Date(feature.attributes.RecordDate).toDateString();
              addtoRef = true;
            }
            //Parcel Maps
            if (Title_id[feature.parentCustomParameters.OCLandInsightsID] == 'Records of Survey'){
              if ((feature.attributes.OBJECTID) && !RS_OIDs.includes(feature.attributes.OBJECTID)){
                RS_OIDs.push(feature.attributes.OBJECTID)
              }
              engsvynum = feature.attributes.EngSvyNum;
              mapnum = feature.attributes.MapNum;
              docRef = feature.attributes.BPNum; 
              maptype = 'Record of Survey';
              datevalue = new Date(feature.attributes.RecordDate).toDateString();
              addtoRef = true;
             
            }

            if (Title_id[feature.parentCustomParameters.OCLandInsightsID] == 'Tract Maps'){
              if ((feature.attributes.OBJECTID) && !TR_OIDs.includes(feature.attributes.OBJECTID)){
                TR_OIDs.push(feature.attributes.OBJECTID)
              }
             
              engsvynum = feature.attributes.EngSvyNum;
              mapnum = feature.attributes.TRNum;
              docRef = feature.attributes.Name 
              maptype = 'Tract Map';
              datevalue = new Date(feature.attributes.RecordDate).toDateString();
              addtoRef = true;
            }

            //Lot Line Adjustments
            if (Title_id[feature.parentCustomParameters.OCLandInsightsID] == 'Lot Line Adjustments'){
              if ((feature.attributes.OBJECTID) && !LLA_OIDs.includes(feature.attributes.OBJECTID)){
                LLA_OIDs.push(feature.attributes.OBJECTID)
              }
              engsvynum = feature.attributes.EngSvyNum;
              mapnum = feature.attributes.LLNum;
              docRef = feature.attributes.Name 
              maptype = 'Lot Line Adjustment';
              datevalue = new Date(feature.attributes.RecordDate).toDateString();
              addtoRef = true;
            }

            if (Title_id[feature.parentCustomParameters.OCLandInsightsID]  == 'Alignment Notes'){
              engsvynum = feature.attributes.ENGSVYNUM;
              mapnum = feature.attributes.MAPNUM;
              docRef = feature.attributes.BPNUM 
              maptype = 'Alignment Note';
              datevalue = new Date(feature.attributes.SURVEYDATE).toDateString();
              addtoRef = true;
            }

            if (Title_id[feature.parentCustomParameters.OCLandInsightsID]  == 'Topographic Surveys'){
              engsvynum = feature.attributes.SrLandSurveyor;
              mapnum = feature.attributes.ProjectName;
              docRef = feature.attributes.SurveyFileNum
              maptype = 'Topographic Surveys';
              datevalue = new Date(feature.attributes.SurveyDate).toDateString();
              addtoRef = true;
            }

            //County Surveyor Tie Books
            if (Title_id[feature.parentCustomParameters.OCLandInsightsID]  == 'County Surveyor Tie Books'){
              engsvynum = "";
              mapnum = feature.attributes.NOTES;
              docRef = feature.attributes.BPNUM
              maptype = 'County Surveyor Tie Book';
              datevalue = new Date(feature.attributes.SURVEYDATE).toDateString();
              addtoRef = true;
            }
          
            //County Surveyor Tie Books
            if (Title_id[feature.parentCustomParameters.OCLandInsightsID]  == 'Jack Raub Notes'){
              engsvynum = "";
              mapnum = "";
              docRef = feature.attributes.FILENAME
              maptype = 'Jack Raub Note';
              datevalue = ""
              addtoRef = true;
            }

            //County Surveyor Tie Books
            if (Title_id[feature.parentCustomParameters.OCLandInsightsID] == 'City Ties'){
              engsvynum = "";
              mapnum = feature.attributes.PAGENUM;
              docRef = feature.attributes.DOCPATH
              maptype = 'City Tie';
              datevalue = feature.attributes.SURVEYDATE
              addtoRef = true;
            }

           let addobj =  {
              id:feature.attributes.OBJECTID,
              layername: item.layerName,
              MapType:maptype,
              No:mapnum,
              DocumentReference:docRef,
              DateField:datevalue,
              LSRE:engsvynum,
              COC:""
            }

            console.log('addobj',addobj)
            if (addtoRef){
              refRows.push(addobj)
            }
            
          })
        
        })
        setRows(refRows);
        if (refRows.length >0){
          let tempRows = [];
          //Add COC here before setRoq
          let coc_docgroups = []
          relateLLAcoc.objectIds = []
          relateRScoc.objectIds = []
          relatePMcoc.objectIds = []
          relateTRcoc.objectIds = []
          

          if (LLA_OIDs.length > 0){
            relateLLAcoc.objectIds = LLA_OIDs
            const qLLA = query.executeRelationshipQuery("https://www.ocgis.com/survey/rest/services/NextGen/DocumentsAndMaps/MapServer/3",relateLLAcoc);
            coc_docgroups.push(qLLA)
          }

          if (RS_OIDs.length > 0){
            relateTRcoc.objectIds = RS_OIDs
            const qRS = query.executeRelationshipQuery("https://www.ocgis.com/survey/rest/services/NextGen/DocumentsAndMaps/MapServer/0",relateRScoc);
            coc_docgroups.push(qRS)
          }

          if (PM_OIDs.length > 0){
            coc_docgroups.push(PM_OIDs)
            relatePMcoc.objectIds = TR_OIDs
            const qPM = query.executeRelationshipQuery("https://www.ocgis.com/survey/rest/services/NextGen/DocumentsAndMaps/MapServer/4",relatePMcoc);
          }

          if (TR_OIDs.length > 0){
            relateTRcoc.objectIds = TR_OIDs
            const qTR = query.executeRelationshipQuery("https://www.ocgis.com/survey/rest/services/NextGen/DocumentsAndMaps/MapServer/6",relateTRcoc);
            coc_docgroups.push(qTR)
          }
          
          if (coc_docgroups.length > 0){
            //https://www.ocgis.com/OCPW/Services/OCSurvey/Document/ShowDoc?DocNum=201200174136&type=MD
            console.log('coc_docgroups',coc_docgroups)
            Promise.all(coc_docgroups).then(function (results){
              console.log('PROMISE ALL',results)
              results.forEach(function(group){
                for (const [oid, value] of Object.entries(group)) {
                  const features = value['features']
                  features.forEach(function(feature){
                    if (coc_dict[oid]){
                        let val = coc_dict[oid]
                        val[feature.attributes.ORNum] = "https://www.ocgis.com/OCPW/Services/OCSurvey/Document/ShowDoc?DocNum="+encodeURIComponent(feature.attributes.ORNum)+"&type=CC";
                        coc_dict[oid] = val;
                      } else {
                      let cocitem ={};
                      cocitem[feature.attributes.ORNum] = "https://www.ocgis.com/OCPW/Services/OCSurvey/Document/ShowDoc?DocNum="+encodeURIComponent(feature.attributes.ORNum)+"&type=CC";
                      coc_dict[oid] = cocitem
                    }
                    
                    console.log(oid,feature.attributes.BPNum,"https://www.ocgis.com/OCPW/Services/OCSurvey/Document/ShowDoc?DocNum="+encodeURIComponent(feature.attributes.ORNum)+"&type=CC")
                  })
                }
              })
              console.log('coc_dict',coc_dict)
              refRows.forEach(function(row){
              console.log('refRows',coc_dict[row.id],row)
              if (coc_dict[row.id]){
              //  coc_dict[row.id]
              let coclinks = '';
                for (const [key, value] of Object.entries(coc_dict[row.id])) {
                  console.log(key, value);
               //   coclinks +='<a href=' + value + ' target="_blank">' + key + '</a> ';
                  coclinks += key + ' ';
                }
              row['COC'] = coclinks
              }
              tempRows.push(row)
            })
            console.log('tempRows',tempRows)
            setRows(tempRows);
            })
          } else {
            
            setRows(refRows);
          }
        }

      setfeatureDict(featDict)
    };
  
    },[payload])

  return {columns,rows,featureDict}
}

export default useSurveyRefDataHook